var map = {
	"./assets/audio/ArcadeWin.ogg": 9,
	"./assets/audio/Bells.ogg": 10,
	"./assets/audio/BigWin.ogg": 11,
	"./assets/audio/BonusWheel_MUSIC_END.ogg": 12,
	"./assets/audio/BonusWheel_MUSIC_LOOP.ogg": 13,
	"./assets/audio/GlitterAir.ogg": 14,
	"./assets/audio/Skeeballthrowroll.ogg": 15,
	"./assets/audio/ballHit1.ogg": 16,
	"./assets/audio/ballHopper.ogg": 17,
	"./assets/audio/balltrayFill.ogg": 18,
	"./assets/audio/beeda_loo.ogg": 19,
	"./assets/audio/blip.ogg": 20,
	"./assets/audio/clack1.ogg": 21,
	"./assets/audio/extraBall.ogg": 22,
	"./assets/audio/failSound.ogg": 23,
	"./assets/audio/fallinHole.ogg": 24,
	"./assets/audio/hit.ogg": 25,
	"./assets/audio/hit2.ogg": 26,
	"./assets/audio/inHole.ogg": 27,
	"./assets/audio/ramp.ogg": 28,
	"./assets/audio/ramp2.ogg": 29,
	"./assets/audio/rampRoll.ogg": 30,
	"./assets/audio/rolldown.ogg": 31,
	"./assets/audio/snare.ogg": 32,
	"./assets/audio/squirtle.ogg": 33
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;



//////////////////
// WEBPACK FOOTER
// ./app ./~/file-loader?name=audio/[name].ogg!^\.\/.*\.ogg$
// module id = 8
// module chunks = 0